export default "__VITE_ASSET__D224fKTu__"